import { z } from "zod";

export const locationSchema = z.object({
  // Address — only streetAddress is required
  streetAddress: z.string().min(1, "Street address is required"),
  city: z.string().optional().or(z.literal("")),
  stateOrRegion: z.string().optional().or(z.literal("")),
  postalCode: z.string().optional().or(z.literal("")),
  country: z.string().optional().or(z.literal("")),
  latitude: z.number().nullable().optional(),
  longitude: z.number().nullable().optional(),

  // Site identity
  propertyName: z.string().optional().or(z.literal("")),
  buildingName: z.string().optional().or(z.literal("")),

  // Work area
  floorOrLevel: z.string().optional().or(z.literal("")),
  elevation: z.string().optional().or(z.literal("")),
  workZoneName: z.string().optional().or(z.literal("")),

  // Access
  primaryEntryRoute: z.string().optional().or(z.literal("")),
  stagingArea: z.string().optional().or(z.literal("")),

  // Guidance
  startHereNote: z.string().optional().or(z.literal("")),

  // AI-generated summaries
  locationSummary: z.string().optional().or(z.literal("")),
  workforceHandoffNote: z.string().optional().or(z.literal("")),
});

export type LocationFormData = z.infer<typeof locationSchema>;
